export default __webpack_public_path__ + "static/media/A95.277066d5.jpeg";